import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/core/models';
import { StorageKey, StorageService } from 'src/app/core/services';
import { VerifyPermissionUrl } from '../utils/verify-permission-url';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.sass']
})
export class AdministrativeDashboardComponent implements OnInit {

  public currentUser: User;

  constructor(
    private storageService: StorageService,
    private verifyPermissionUrl: VerifyPermissionUrl
  ) { }

  ngOnInit(): void {
    this.getCurrentUser();
    this.validations();
  }

  getCurrentUser() {
    this.currentUser = this.storageService.get(StorageKey.currentUser);
  }

  validations() {
    if (!this.currentUser?.adminManagerUser) {
      this.verifyPermissionUrl.execute([
        'ViewContract',
        'ViewCompany',
        'ViewAppraisal'
      ]);
    }
  }

}
